import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import { ResourceManagementLandingPage } from 'components/pages/resource-management/feature-discovery';
import { useIsCurrentUserCollaborator } from 'hooks/permissions';
import { useUser } from 'hooks/use-user';
import { useResourceManagementConfigQuery } from 'queries/resource-management-configuration';
import { ResourceManagementMainRoute } from './resource-management-route';

export const ResourceManagementRoute: FC = () => {
  const {
    userMeta: { metaData },
  } = useUser();
  const history = useHistory();
  const isCollaborator = useIsCurrentUserCollaborator();
  const { data: resourceManagementConfig, isLoading } =
    useResourceManagementConfigQuery();
  const isEnabledForCollaborator =
    resourceManagementConfig?.accessConfig?.collaboratorAccessMeta
      ?.hasViewAccess ?? false;

  const startedWithResourceManagement = metaData?.startedWithResourceManagement;

  if (isCollaborator) {
    if (isLoading) {
      return <PageLoading />;
    }
    if (!isEnabledForCollaborator) {
      history.push('/');

      return <></>;
    }
  }

  return startedWithResourceManagement ? (
    <ResourceManagementMainRoute />
  ) : (
    <ResourceManagementLandingPage />
  );
};
